var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactFeature1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1987_15072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9851 55.7444L55.2713 29.7743C55.2243 29.515 55.0635 29.2905 54.8331 29.1624L42.9688 22.5636C42.8148 22.4778 42.6422 22.4437 42.4727 22.4568L44.6311 50.3016L44.5588 50.3339L58.7578 56.7039C58.8733 56.7556 58.9961 56.7811 59.1184 56.7811C59.3118 56.7811 59.5035 56.7175 59.6612 56.5941C59.9187 56.393 60.0433 56.0658 59.9851 55.7444Z",
    fill: "#44C868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.999 28.8723L17.8648 22.5522C17.7194 22.4764 17.5581 22.4455 17.3993 22.4561C17.4414 22.4536 17.4837 22.4538 17.5257 22.4571L15.3672 50.3018L29.6384 56.7043C29.7536 56.7558 29.8766 56.7815 29.999 56.7815V28.8723Z",
    fill: "#44C868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5266 22.4568C17.357 22.4437 17.1844 22.4778 17.0304 22.5635L5.16597 29.1623C4.93558 29.2904 4.7748 29.5148 4.72781 29.7741L0.0141654 55.7442C-0.0441941 56.0656 0.0804936 56.3928 0.337955 56.5941C0.495807 56.7175 0.687409 56.7811 0.880769 56.7811C1.003 56.7811 1.12593 56.7557 1.24136 56.7039L15.3629 50.3686L17.5266 22.4568Z",
    fill: "#4CE166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4733 22.4561C42.3566 22.4651 42.2412 22.4961 42.1342 22.5519L30 28.8718V56.781H30.0001C30.1226 56.781 30.2456 56.7555 30.3607 56.7038L44.6319 50.3014L42.4733 22.4561Z",
    fill: "#4CE166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29738 37.6449L2.33984 42.9205L16.5189 35.4315L16.848 31.1848L16.9026 30.4805L3.29738 37.6449Z",
    fill: "#FFDB56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6484 33.7842L16.5208 35.4309L2.34175 42.9199L0.0141654 55.7441C-0.0441941 56.0654 0.0804936 56.3926 0.337955 56.594C0.495807 56.7174 0.687409 56.781 0.880769 56.781C1.003 56.781 1.12593 56.7556 1.24136 56.7038L15.3629 50.3685L16.6484 33.7842Z",
    fill: "#A8EEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0023 32.3525L16.9033 30.4795L16.5195 35.4306L29.9988 55.9008V48.4573L21.9554 35.7918L30.0023 36.7543V32.3525Z",
    fill: "#FFBB24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8997 28.6427L48.2002 25.4727L42.8047 26.7334L42.8722 27.6048L43.1387 31.0424L53.8997 28.6427Z",
    fill: "#FFBB24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6178 37.2156L43.1069 30.6239L42.8054 26.7334L30.0039 32.3528V36.7546L38.366 33.1183L43.6178 37.2156Z",
    fill: "#FFDB56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9875 55.7446L58.8036 49.2212L43.1406 31.043L43.6192 37.2162L59.6821 56.5781C59.9264 56.3757 60.0444 56.0579 59.9875 55.7446Z",
    fill: "#FFBB24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0571 3.21875C23.2645 3.21875 17.7383 8.7404 17.7383 15.5274C17.7383 19.7258 19.7315 24.2333 23.6628 28.9246C26.5502 32.3703 29.3983 34.5864 29.5182 34.6791C29.6769 34.8018 29.867 34.8631 30.0572 34.8631C30.2473 34.8631 30.4374 34.8018 30.5961 34.6791C30.7159 34.5864 33.5641 32.3703 36.4515 28.9246C40.3828 24.2333 42.3761 19.7259 42.3761 15.5274C42.3758 8.7404 36.8496 3.21875 30.0571 3.21875ZM34.6192 15.5273C34.6192 18.0448 32.5766 20.0857 30.0571 20.0857C27.5375 20.0857 25.4949 18.0449 25.4949 15.5273C25.4949 13.0098 27.5375 10.969 30.0571 10.969C32.5766 10.969 34.6192 13.0099 34.6192 15.5273Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0577 3.21875C29.5193 3.21875 28.9891 3.25367 28.4688 3.32094C34.5136 4.10223 39.1987 9.27829 39.1987 15.5274C39.1987 19.7258 37.2054 24.2333 33.2742 28.9246C31.4173 31.1404 29.578 32.8465 28.4689 33.8077C29.0846 34.3411 29.4762 34.646 29.5189 34.6791C29.6775 34.8018 29.8676 34.8631 30.0578 34.8631C30.2479 34.8631 30.4381 34.8018 30.5968 34.6791C30.7165 34.5864 33.5648 32.3703 36.4522 28.9246C40.3835 24.2333 42.3767 19.7259 42.3767 15.5274C42.3765 8.7404 36.8503 3.21875 30.0577 3.21875Z",
    fill: "#E7343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3607 56.7042L35.6676 54.3234L30 48.458V56.7814H30.0001C30.1226 56.7814 30.2455 56.756 30.3607 56.7042Z",
    fill: "#FFDB56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2699 29.7739C55.2229 29.5147 55.0621 29.2902 54.8317 29.1621L53.8977 28.6426L43.1367 31.0422L58.7996 49.2205L55.2699 29.7739Z",
    fill: "#1EA4E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9991 56.7807C29.9992 56.7807 29.9992 56.7807 29.9991 56.7807V55.9009L16.52 35.4307L15.3672 50.3012L29.6384 56.7036C29.7536 56.7553 29.8766 56.7807 29.9991 56.7807Z",
    fill: "#1EA4E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1987_15072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFeature1);
export default __webpack_public_path__ + "static/media/contact_feature_1.6af1ea3e3c5a197f2367dd3257cbdab7.svg";
export { ForwardRef as ReactComponent };